import axios from "axios";
import axiosConstants from "../axiosConstants";
import { RequestResponse, User, UserType } from "../types";

export const getUsersAndPermissions: () => Promise<RequestResponse<User>> =
  async () => {
    try {
      const userRequest = axios.get(axiosConstants.USER_URL);
      const permissionsRequest = axios.get(axiosConstants.PERMISSIONS_URL);
      const [userResponse, permissionsResponse] = await Promise.all([
        userRequest,
        permissionsRequest
      ]);

      const userType: UserType =
        userResponse.data.domainCode === "ISW" ? "ISW_ADMIN" : "INSTITUTION";

      const data: User = {
        ...userResponse.data,
        userType,
        permissionsMap: permissionsResponse.data.reduce(
          (map: Record<string, boolean>, permission: any) => ({
            ...map,
            [permission.authority]: true
          }),
          {}
        )
      };
      console.log({ userAndPerms: data });
      return { error: false, data };
    } catch (e) {
      console.log("Error fetching user data: ", e);
      return {
        error: true,
        message: `Error fetching user data: ${e.message}`,
        data: null
      };
    }
  };
